import * as actionTypes from '../Actions/ActionTypes'

const initialState = {
  myCompany: null,
  products: [],
  visitedCompanies: [],
  homePageCompanies: [],
}

const getMycompanySuccess = (state, action) => {
  let { myCompany } = action.payload

  return {
    ...state,
    myCompany,
  }
}

const clearCompanyRedux = () => {
  return {
    ...initialState,
  }
}

const getMyCompanyProductsSuccess = (state, action) => {
  const { products } = action.payload
  return {
    ...state,
    products,
  }
}

const saveVisitedCompany = (state, action) => {
  const visitedCompanies = state.visitedCompanies ?? []
  const { visitData } = action.payload

  return {
    ...state,
    visitedCompanies: [...visitedCompanies, visitData],
  }
}

const deleteVisitedCompanies = state => {
  const visitedCompanies = state.visitedCompanies ?? []

  // Remove companies visited < 60 minutes ago
  const now = Date.now()
  const filtered = visitedCompanies.filter(company => {
    const diffInMinutes = (now - company.visitTime) / (1000 * 60)
    if (diffInMinutes < 60) {
      return company
    }
  })

  return {
    ...state,
    visitedCompanies: [...filtered],
  }
}

const getHomePageCompaniesSuccess = (state, action) => {
  const { companies } = action.payload

  return {
    ...state,
    homePageCompanies: companies,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MY_COMPANY_SUCCESS:
      return getMycompanySuccess(state, action)
    case actionTypes.GET_MY_COMPANY_PRODUCTS_SUCCESS:
      return getMyCompanyProductsSuccess(state, action)
    case actionTypes.CLEAR_COMPANY_REDUX:
      return clearCompanyRedux()
    case actionTypes.SAVE_VISITED_COMPANY:
      return saveVisitedCompany(state, action)
    case actionTypes.DELETE_VISITED_COMPANIES:
      return deleteVisitedCompanies(state)
    case actionTypes.GET_HOME_PAGE_COMPANIES_SUCCESS:
      return getHomePageCompaniesSuccess(state, action)

    default:
      return state
  }
}

export default reducer
